import { ErrorHandler, Injectable } from '@angular/core';
import { ClientLoggingApiService } from '../generated/api/client-logging/client-logging.service';
import { LoggingRequest } from '../generated/api/kreditportalBackendAPI.schemas';

@Injectable()
export class PostErrorHandler extends ErrorHandler {

    constructor(private readonly clientLoggingApiService: ClientLoggingApiService) {
        super();
    }

    override handleError(error: Error) {
        // try-catch um Endlosschleife zu vermeiden
        try {
            const logRequest: LoggingRequest = {
                name: error.name,
                message: error.message,
                stack: error.stack
            };

            this.clientLoggingApiService.log(logRequest);
        } catch (e) {
            console.error('Fehler beim Senden eines Error-Traces', e);
        }

        super.handleError(error);
    }

}
